var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('owner-reservation-setup',{attrs:{"setup_parameter":_vm.SETUP_PARAMETER_RESERVATION_NOTE_SETUP}})}
var staticRenderFns = []

export { render, staticRenderFns }